import { forwardRef, useCallback } from 'react';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconFilledProps, IconRender } from '../types.ts';

const MouseCursor = forwardRef<SVGSVGElement | null, IconFilledProps>(function MouseCursor({ filled, dataTestId, ...props }, ref) {
  // eslint-disable-next-line no-restricted-syntax
  const iconRender = useCallback<IconRender>(
    (color: string) => (
      <>
        {/* default */}
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M3.78552 3.5076C3.56326 2.68599 4.42563 1.94533 5.21366 2.36852L20.5319 10.5948C21.5748 11.1548 21.4594 12.6998 20.335 13.0902L16.319 14.4843L19.7181 18.7339C20.1963 19.3318 20.0917 20.2109 19.4807 20.6772L18.4397 21.4716C17.8521 21.9201 17.0183 21.8147 16.5583 21.2396L13.1057 16.923L10.6967 20.4694C10.0389 21.4378 8.565 21.1755 8.26261 20.0577L3.78552 3.5076ZM5.53917 4.24594L9.6304 19.3696L12.6265 14.9591C12.8156 14.6806 13.2203 14.6648 13.4305 14.9277L17.6422 20.1933L18.4634 19.5667L14.2636 14.3161C14.048 14.0465 14.164 13.6446 14.4901 13.5314L19.5554 11.773L5.53917 4.24594Z'
          fill={filled ? 'transparent' : color}
        />
        {/* filled */}
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M3.78552 3.5076C3.56326 2.68599 4.42563 1.94533 5.21366 2.36852L20.5319 10.5948C21.5748 11.1548 21.4594 12.6998 20.335 13.0902L16.319 14.4843L19.7181 18.7339C20.1963 19.3318 20.0917 20.2109 19.4807 20.6772L18.4397 21.4716C17.8521 21.9201 17.0183 21.8147 16.5583 21.2396L13.1057 16.923L10.6967 20.4694C10.0389 21.4378 8.565 21.1755 8.26261 20.0577L3.78552 3.5076Z'
          fill={filled ? color : 'transparent'}
        />
      </>
    ),
    [filled],
  );
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'mouse-cursor-icon-svg'} iconRender={iconRender} {...props} />;
});

export default MouseCursor;
